import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/images/sulthaniya_logo.png';
import { IconDashboard, IconUsers, IconRoles, IconContent, IconPosts, IconBooks, IconHomeTabs, IconAnnouncements, IconFeedback, IconAnalytics, IconQuotes, IconAudio, IconVideo, IconSettings, IconSignOut } from './Icons';

const NAV = [
  { to: '/',              Icon: IconDashboard,     label: 'Dashboard' },
  { to: '/users',         Icon: IconUsers,         label: 'Users' },
  { to: '/roles',         Icon: IconRoles,         label: 'Roles' },
  { to: '/content',       Icon: IconContent,       label: 'Content' },
  { to: '/posts',         Icon: IconPosts,         label: 'Posts' },
  { to: '/books',         Icon: IconBooks,         label: 'Books' },
  { to: '/home-tabs',     Icon: IconHomeTabs,      label: 'Home Tabs' },
  { to: '/quotes',        Icon: IconQuotes,        label: 'Quotes' },
  { to: '/audio',         Icon: IconAudio,         label: 'Audio' },
  { to: '/video',         Icon: IconVideo,         label: 'Video' },
  { to: '/announcements', Icon: IconAnnouncements, label: 'Announcements' },
  { to: '/feedback',      Icon: IconFeedback,      label: 'Feedback' },
  { to: '/analytics',     Icon: IconAnalytics,     label: 'Analytics' },
  { to: '/settings',      Icon: IconSettings,      label: 'Site Settings' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <aside style={{
      width: 220, minWidth: 220,
      background: 'var(--accent2)',
      display: 'flex', flexDirection: 'column',
      height: '100vh', position: 'sticky', top: 0,
    }}>
      {/* Logo */}
      <div style={{ padding: '20px 20px 18px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src={logo} alt="Sulthaniya Foundation" style={{ width: 38, height: 38, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }}/>
          <div>
            <div style={{ fontFamily: 'var(--serif)', fontSize: 15, color: '#fff', lineHeight: 1.2, fontWeight: 700 }}>
              Sulthaniya
            </div>
            <div style={{ fontSize: 9, color: '#a8d5ba', letterSpacing: '.12em', textTransform: 'uppercase', marginTop: 1 }}>
              Foundation Admin
            </div>
          </div>
        </div>
        <div style={{ height: 1, background: '#ffffff18', marginTop: 18 }}/>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '0 10px' }}>
        {NAV.map(({ to, Icon, label }) => (
          <NavLink key={to} to={to} end={to === '/'} style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '9px 12px', borderRadius: 8, marginBottom: 2,
            color: isActive ? '#fff' : '#7fc8a0',
            background: isActive ? '#ffffff18' : 'transparent',
            fontSize: 13, fontWeight: isActive ? 500 : 400,
            transition: 'all .15s', textDecoration: 'none',
          })}>
            <span style={{ display: 'flex', alignItems: 'center', opacity: .9 }}><Icon /></span>
            {label}
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div style={{ padding: '16px 14px', borderTop: '1px solid #ffffff18' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <div style={{
            width: 34, height: 34, borderRadius: '50%',
            background: '#ffffff22', display: 'flex', alignItems: 'center',
            justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#fff', flexShrink: 0,
          }}>
            {user?.name?.charAt(0).toUpperCase()}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
            <div style={{ fontSize: 10, color: '#7fc8a0' }}>Administrator</div>
          </div>
        </div>
        <button onClick={logout} style={{
          width: '100%', background: '#ffffff12', border: 'none',
          borderRadius: 7, padding: '7px 10px', color: '#a8d5ba',
          fontSize: 12, cursor: 'pointer', transition: 'background .15s',
          display: 'flex', alignItems: 'center', gap: 7,
        }}>
          <IconSignOut /> Sign out
        </button>
      </div>
    </aside>
  );
}
